export default "__VITE_ASSET__Co2lagRK__"